module.exports = "/_next/static/images/IlloUseCaseOptimizeAdSpendHover-5db51405cec3d79fe847da7d3dff3e82.png";